// extracted by mini-css-extract-plugin
export default {"link":"social-links-WebsiteLink__link--2j5lO","icon":"social-links-WebsiteLink__icon--3OiCn"};